@use "../../../../../globals/bcp";
@use "../f-navigation";
@use "../../../../../globals/libs/hy.core.css/objects/button-starter" as buttons;

$default-transition-easing: cubic-bezier(0.38, 0.04, 0.35, 0.96);
$default-transition-timing: 0.25s;

$self: ".f-main-navigation-trigger";

.f-main-navigation-trigger {
  @include bcp.respond-gte(tabletl) {
    display: none;
  }

  @include bcp.respond-lte(tabletp) {
    $icon-offset-left: 0;
    $icon-offset-top: 0;

    @include buttons.button-reset;
    background: f-navigation.$menu-icon-bg;
    color: f-navigation.$menu-icon-color;
    border: 0;
    padding: 11px; // random number to bring clickable area to WCAG requirements
    position: relative;
    left: -11px;
    cursor: pointer;

    &__icon {
      position: relative;
      display: block;
      width: 20px;
      height: 20px;
      padding: 0;
      box-sizing: border-box;
    }

    &__icon-bar {
      position: absolute;
      top: $icon-offset-top;
      left: $icon-offset-left;
      margin: 0;
      display: block;
      width: bcp.size(18);
      height: 0;
      border-top: 1px solid f-navigation.$menu-icon-color;
      transition: transform $default-transition-easing
          $default-transition-timing,
        opacity $default-transition-easing $default-transition-timing;

      &:nth-child(1) {
        top: $icon-offset-top + bcp.size(1.5);
      }

      &:nth-child(2),
      &:nth-child(3) {
        top: $icon-offset-top + bcp.size(7.5);
      }

      &:nth-child(4) {
        top: $icon-offset-top + bcp.size(13.5);
      }
    }

    &:hover {
      color: f-navigation.$menu-icon-color-hover;
    }

    &:hover #{$self}__icon-bar {
      border-top-color: f-navigation.$menu-icon-color-hover;
    }

    &:active {
      color: f-navigation.$menu-icon-color-active;
    }

    &:active #{$self}__icon-bar {
      border-top-color: f-navigation.$menu-icon-color-active;
    }

    &.is-active #{$self}__icon-bar {
      &:nth-child(1) {
        transform: scaleX(0) translateY(bcp.size(6));
        opacity: 0;
      }

      &:nth-child(2) {
        transform: rotate(45deg) scaleX(1.2);
      }

      &:nth-child(3) {
        transform: rotate(-45deg) scaleX(1.2);
      }

      &:nth-child(4) {
        transform: scaleX(0) translateY(bcp.size(-6));
        opacity: 0;
      }
    }
  }
}

// ------------------- CUSTOM -----------------------------------------------------------------------------------------
// ...
